import * as React from 'react';
import moment from 'moment';
import Icon from 'antd/lib/icon';
import GenericHoc from 'src/components/hoc/GenericHoc';
import Loader from 'src/components/common/Loader';
import Timeline from 'antd/lib/timeline';
import { StylesProps } from 'src/Library/Types';
import { getCourierTracking } from 'src/api/shipmentExecution';
import { CourierTrackingData, Events } from './tracking.types';
import { statusPrettyNameMap } from './tracking.constants';
import { courierTrackingStyles } from './tracking.styles';
import { snakeToPretty } from 'src/Library/Helper';
import { HocOptions } from 'src/components/hoc/GenericHoc.types';
import GetExecutionData from 'src/dto/response/getExecution';

const noDocumentsImg = require('src/assets/images/noDocuments.png');

interface IProps extends StylesProps<typeof courierTrackingStyles> {
  awbNumber: string;
  selectedShipment: GetExecutionData;
}

const CourierTracking = (props: IProps) => {
  const { classes, selectedShipment, awbNumber } = props;
  const [loading, setLoading] = React.useState<boolean>(true);
  const [trackingData, setTrackingData] = React.useState<CourierTrackingData | undefined>();

  const loadData = async () => {
    setLoading(true);
    const result = await getCourierTracking(selectedShipment.id);
    if (result.isSuccess) {
      setTrackingData(result.data);
    } 
    setLoading(false);
  };

  React.useEffect(() => {
    console.log(selectedShipment.id);
    if (!selectedShipment.id) {
      return ;
    }
    loadData();
  }, [selectedShipment.id]);

  const renderAwbNumber = () => {
    return <div className={classes.referenceList}>
      <div className={classes.referenceValue}>{awbNumber || '-'}</div>
      <div className={classes.referenceTitle}>AWB#</div>
    </div>;
  };

  // const renderCourierPartner = () => {
  //   return <div className={classes.flexColumn}>
  //     <div className={classes.title}>Courier Partner</div>
  //     <div className={classes.value}>{shipment?.courierPartner || '-'}</div>
  //   </div>;
  // };

  const renderStatus = () => {
    const { status } = trackingData || {};

    return <div className={classes.referenceList}>
      <div className={classes.referenceValue}>{status && statusPrettyNameMap[status] ?
        statusPrettyNameMap[status]:  snakeToPretty(status) || '-'}</div>
      <div className={classes.referenceTitle}>Status</div>
    </div>;
  };

  const renderTransitDays = () => {
    return <div className={classes.referenceList}>
      <div className={classes.referenceValue}>{trackingData?.transit_days || '-'}</div>
      <div className={classes.referenceTitle}>Transit Days</div>
    </div>;
  };

  const renderTotalAttempts = () => {
    return <div className={classes.referenceList}>
      <div className={classes.referenceValue}>{trackingData?.attempt_count || '-'}</div>
      <div className={classes.referenceTitle}>Total Attempts</div>
    </div>;
  };

  const totalSinceLastScan = () => {
    return <div className={classes.referenceList}>
      <div className={classes.referenceValue}>{trackingData?.total_since_last_scan || '-'}</div>
      <div className={classes.referenceTitle}>Total Since Last Scan</div>
    </div>;
  };

  const header = () => {
    return  <div className={classes.reference}>
    {/* return <div className={classes.header}> */}
      {/* {renderReferenceNumber()} */}
      {renderAwbNumber()}
      {/* {renderCourie rPartner()} */}
      {renderStatus()}
      {renderTransitDays()}
      {renderTotalAttempts()}
      {totalSinceLastScan()}
    </div>;
  };

  const dot = () => {
    return <Icon
      type="check-circle"
      theme="filled"
      className={classes.dot}
    />;
  };

  const lineitemLeft = (event: Events) => {
    return <div className={classes.lineItemLeft} style={{ width: '20%' }}>
      <div className={classes.date}>
        {moment(event.event_time).format('DD MMM, YYYY')}
      </div>
      <div className={classes.time}>
        {moment(event.event_time).format('HH:mm A')}
      </div>
    </div>;
  };

  const lineitemRight = (event: Events) => {
    return <div
      className={classes.lineItemLeft}
      style={{ width: '60%' }}>
      <div className={classes.textRight}>
        {event.notes || snakeToPretty(event.type)}
      </div>
      <div
        className={classes.locationRight}
        style={{
          alignSelf: 'flex-start'
        }}>
        {event.location_string}
      </div>
    </div>;
  };

  const timelineItem = (event: Events, idx: number) => {
    const numberOfEvents = trackingData?.events?.length || 0;
    return <div className={classes.flexRow}>
      {lineitemLeft(event)}
      <Timeline.Item
        className={(idx === numberOfEvents - 1) ? classes.lineItemNoTail : classes.timelineItem}
        dot={dot()}>
      </Timeline.Item>
      {lineitemRight(event)}
    </div>;
  };

  const timeline = () => {
    return <Timeline className={classes.timeline}>
      {trackingData?.events?.map((item: Events, idx: number) => (timelineItem(item, idx)))}
    </Timeline>;
  };

  const tracking = () => {
    return <div className={classes.trackingBox}>
      {timeline()}
    </div>;
  };

  const renderContent = () => {
    if (loading) {
      return <Loader
        style={{  marginLeft: '0px', marginTop: '25px' }}
        zIndex={1}
      />;
    }
    if (!trackingData) {
      return <div className={classes.noDocument}>
        <img src={noDocumentsImg} style={{ width: 400 }}></img>
        <div style={{ fontSize: 24 }}>
          Tracking Not Available
        </div>
      </div>;
    }
    return <React.Fragment>
      {header()}
      {tracking()}
    </React.Fragment>;
  };

  return <div className={classes.mainDiv}>
    {renderContent()}
  </div>;
};

const options: HocOptions = {
  connectJss: {
    useJss: true,
    styleSheet: courierTrackingStyles,
  },
};

const Courier = GenericHoc(options)(CourierTracking);
export default Courier;
